import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import Grid from '@mui/material/Grid2';
import { Blog } from '../../interfaces/Blog/Blog';
import { getBlogs } from '../../api/Blog';
import { bodyWidth } from '../../utils/Style';
import { settingsAtom } from '../../atoms/Settings';
import { BlogPreview } from './BlogPreview';
import { BlogPlaceholder } from './BlogPlaceholder';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';
import { BreadcrumbElement } from '../../interfaces/Breadcrumb/BreadcrumbElement';
import { GenericBreadcrumbs } from '../../components/Breadcrumbs/GenericBreadcrumbs';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export const BlogsPage = () => {
  const t = useLocalizedText();

  const settings = useRecoilValue(settingsAtom);

  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getBlogs()
      .then((b) => setBlogs(b))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  const itemSize = {
    xs: 12,
    lg: 6,
  };

  const title = settings.settingsV1.blog_text || t('blog.title');

  const breadcrumbElements: BreadcrumbElement[] = [
    {
      name: title,
      url: 'blog',
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet
        title={title}
        meta={{
          title,
          description: settings.settingsV1.blog_description,
          canonicalURL: 'blog',
        }}
        breadcrumb={breadcrumbElements}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          py: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <GenericBreadcrumbs breadcrumbElements={breadcrumbElements} />

        <Typography sx={{ fontSize: '22px', fontWeight: 700 }}>
          {title}
        </Typography>

        <Grid container spacing={{ xs: 3 }} width='100%'>
          {loading
            ? Array(12)
                .fill(null)
                .map((_, i) => (
                  <Grid key={i} size={itemSize}>
                    <BlogPlaceholder />
                  </Grid>
                ))
            : blogs.map((blog) => (
                <Grid key={blog.id} size={itemSize}>
                  <BlogPreview blog={blog} />
                </Grid>
              ))}
        </Grid>
      </Box>
    </Box>
  );
};
